/**
 * ADGMQ
 * imedia
 *
 * Custom File
 */

(function($) {
  $(document).ready(function() {
    $('.custom-file-input').on('change', function() {
      console.log($(this).get(0).files.length);
      if ($(this).get(0).files.length >= 2) {
        $(this)
          .parent()
          .next()
          .attr('data-label', $(this).get(0).files.length + ' fichiers');
      } else {
        $(this)
          .parent()
          .next()
          .attr(
            'data-label',
            $(this)
              .val()
              .replace(/C:\\fakepath\\/, ''),
          );
      }
    });
  });
})(jQuery);
